import type { Placement } from '../../gql';

import { randNumber, randUuid } from '@ngneat/falso';

const mockPlacementNames = [
    'full',
    'body',
    'front',
    'back',
    'belt',
    'waist band',
    'cuff',
    'pocket',
    'pocket flap',
    'panel',
];

export const mockPlacement = (overwrite?: Partial<Placement>): Placement => ({
    placementPublicId: randUuid(),
    placementName: mockPlacementNames[randNumber({ max: 9 })],
    ...overwrite,
    ['__typename']: 'Placement',
});
